import React from 'react';
import { connect } from 'react-redux';

import '../css/cart-quantity-indicator.less';

class CartQuantityIndicator extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			recentlyAdded: 1
		}
	}

	componentDidUpdate(prevProps) {
		let newCartQty = this.props.cartInfo.tQty;
		let oldCartQty = prevProps.cartInfo.tQty;
		
		if (newCartQty > oldCartQty) {
			this.setState({ recentlyAdded: this.state.recentlyAdded + (newCartQty - oldCartQty)})
		}

		if (newCartQty < oldCartQty) {
			this.setState({ recentlyAdded: this.state.recentlyAdded - (oldCartQty - newCartQty) > 0 ? 
				this.state.recentlyAdded - (oldCartQty - newCartQty) : 0 })
		}
	}

	render() {
		const { recentlyAdded } = this.state;
		const { device, className } = this.props;
		return(
			<div className={`xsell-indicator-wrapper${ className ? ' ' + className : ''}`}>
				{device !== 'mobile' ? 
					`${recentlyAdded} ${recentlyAdded > 1 ? 'items' : 'item'} added to your cart` :
					`${recentlyAdded} ${recentlyAdded > 1 ? 'items' : 'item'} added`}
			</div>
		)
	}
}

const mapStateToProps = (state) => ({ cartInfo: state.cartInfo });

export default connect(mapStateToProps, null)(CartQuantityIndicator);
